<template>
  <div>
    <vjs-modal :title="res_title" :name="name"
               v-bind="$options.propsData"
               @opened="open">
      <template #body-content>
        <form v-if="artwork" @submit.prevent>
          <b-row>
            <b-col cols="12">
              <div class="form-group kt-form__group">
                <label :for="'name'+artwork.uuid">Name</label>
                <input :id="'name'+artwork.uuid" v-model="original_artwork_name"
                       type="text" class="form-control kt-input"
                       placeholder="Enter Name">
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label :for="`${artwork.uuid}-tags`">Tags</label>
                <multiselect v-if="auto_complete_tags.length || ms_tag_values.length"
                             v-model="ms_tag_values"
                             :name="`${artwork.uuid}-tags`"
                             :options="auto_complete_tags"
                             :multiple="true"
                             :taggable="true"
                             track-by="uuid"
                             label="name"
                             placeholder="Search for or add tags..."
                             @tag="addNewTag" />
                <div v-else>
                  <b-spinner label="Loading tags..." />
                </div>
                <p>
                  <small> Use comma, space, semicolon or enter to add tags. Tags cannot contain spaces and special characters. Use _ or - to separate multiple words.</small>
                </p>
              </b-form-group>
            </b-col>
          </b-row>

          <artwork-detail-list v-if="details" :details="details" class="mb2" />
        </form>
      </template>
      <template #body-controls>
        <button type="button" class="btn btn-ss-standout" @click="() => close(true)">
          Submit
        </button>
        <button class="btn btn-ss-cancel" @click="() => close(false)">
          Close
        </button>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

import ArtworkDetailList from 'VuePartials/Artwork/ArtworkDetailList';

import { patchArtworks } from 'Lib/artwork';
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';

export default {
  components: {
    BSpinner,
    ArtworkDetailList,
    VjsModal,
  },
  mixins: [TaggableModelMixin, VjsModalMixin],
  props: {
    artwork: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    original_artwork_name: ``,
  }),
  computed: {
    details() {
      return this.artwork?.artwork_detail;
    },
    res_title() {
      return `Editing ${this.artwork?.original_name}`;
    },
  },
  watch: {
    artwork(new_aw) {
      this.ms_tag_values = new_aw.tags ?? [];
    },
  },
  mounted() {
    this.fetchTags();
  },
  methods: {
    open() {
      this.ms_tag_values = this.artwork.tags ?? [];
      this.original_artwork_name = this.artwork?.original_name;
    },
    async close(update) {
      this.close_data.update = update;

      if (update) {
        const api_response = (await patchArtworks({
          ...this.artwork,
          tags: this.ms_tag_values.map(tag => tag.name),
          name: this.original_artwork_name,
        }))[0].data.data;

        this.close_data.old_artwork = this.artwork;
        this.close_data.new_artwork = api_response;
      } else {
        this.close_data.artwork = this.artwork;
      }

      this.complete();
    },
  },
};
</script>

<style lang="scss">
    @use "sass:map";

    @use "~AssetsSass/_variables.scss" as *;

    .artwork-details-cols {
      li {
        white-space: pre;
      }
    }

    .autocomplete {
        position: inherit !important;
        .item {
            background-color: #fff;
            width: 100% !important;
            color: inherit;
            margin-bottom: 0;

            &:hover {
                background-color: map.get($ss, 'primary');
            }
        }
    }

    .ti-autocomplete {
        height: 100px;
        overflow-y: scroll;
    }
</style>
